import { ApolloClient, gql, TypedDocumentNode } from '@apollo/client'
import type {
  DeleteCostPlaceMutation,
  DeleteCostPlaceMutationVariables
} from './__generated__/DeleteCostPlaceMutation'

const mutation: TypedDocumentNode<
  DeleteCostPlaceMutation,
  DeleteCostPlaceMutationVariables
> = gql`
  mutation DeleteCostPlaceMutation($input: DeleteCostPlaceInput!) {
    deleteCostPlace(input: $input) {
      status
    }
  }
`

export function deleteCostPlaceMutation(
  apolloClient: ApolloClient,
  options: Omit<
    ApolloClient.MutateOptions<
      DeleteCostPlaceMutation,
      DeleteCostPlaceMutationVariables
    >,
    'mutation'
  >
) {
  return apolloClient.mutate({
    mutation,
    ...options
  })
}
